import React from 'react';
export function TermsContent() {
  return <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-144">
      <p className="text-sm text-[#8b6f6f]" data-id="element-145">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-146">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-147">
          1. Aceptación de los Términos
        </h2>
        <p data-id="element-148">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, usted acepta estar sujeto a estos Términos y Condiciones.
          Si no está de acuerdo con alguna parte de estos términos, no debe
          utilizar nuestros servicios.
        </p>
      </section>

      <section data-id="element-149">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-150">
          2. Descripción del Producto
        </h2>
        <p data-id="element-151">
          "El Divorcio Emocional" es un producto digital en formato PDF que
          incluye:
        </p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-152">
          <li data-id="element-153">Guía completa en formato PDF descargable</li>
          <li data-id="element-154">
            Bonus especial: "Microgestos Femeninos Que Reviven la Intimidad"
          </li>
          <li data-id="element-155">Acceso inmediato tras la compra</li>
          <li data-id="element-156">Compatible con todos los dispositivos</li>
        </ul>
      </section>

      <section data-id="element-157">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-158">
          3. Precio y Pago
        </h2>
        <p data-id="element-159">
          El precio del producto es de $12.99 USD. El pago se procesa de forma
          segura a través de Hotmart.
        </p>
      </section>

      <section data-id="element-160">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-161">
          4. Propiedad Intelectual
        </h2>
        <p data-id="element-162">
          Todo el contenido está protegido por derechos de autor. Usted recibe
          una licencia personal, no transferible, para usar el material.
        </p>
      </section>
    </div>;
}